import React from 'react';

// As on the live site: the video spans the content width and the channel button
// sits at the right end of the section header row.
const VideoSection = ({ videoUrl }) => {
  return (
    <section className="ff-page__section ff-home-video-section" aria-labelledby="ff-home-video-title">
      <div className="ff-page__section-head ff-home-video-section__head">
        <h2 id="ff-home-video-title" className="ff-page__section-title ff-home-section-title">
          Latest video
        </h2>
        <a
          href="https://www.youtube.com/@FlightFormula"
          target="_blank"
          rel="noopener noreferrer"
          className="ff-button-ghost ff-home-video-section__cta"
        >
          Watch the channel
          <span className="ff-visually-hidden"> (opens YouTube in a new tab)</span>
        </a>
      </div>

      <div className="ff-video-frame ff-video-frame--16x9">
        <iframe
          src={videoUrl}
          title="FlightFormula latest YouTube video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          loading="lazy"
          className="ff-video-embed"
        />
      </div>
    </section>
  );
};

export default VideoSection;
